<template>
  <el-row :gutter="20" type="flex" justify="center">
    <el-col :span="4">
      <span class="header-class-info">{{ className }}</span>
    </el-col>
    <el-col :span="16">
      <el-menu :default-active="activeIndex" class="el-menu-nav-bar" mode="horizontal">
        <span></span>
        <el-menu-item index="1">
          <router-link :to="'/class/' + $route.params.class_id">Introduction</router-link>
        </el-menu-item>
        <el-menu-item index="2">
          <router-link :to="'/class/' + $route.params.class_id + '/discussions'">Discussion</router-link>
        </el-menu-item>
        <el-menu-item index="3">
          <router-link :to="'/class/' + $route.params.class_id + '/downloads'">Download</router-link>
        </el-menu-item>
        <el-menu-item index="4">
          <router-link :to="'/class/' + $route.params.class_id + '/homeworks'" >Homework</router-link>
        </el-menu-item>
        <el-menu-item index="5">
          <router-link :to="'/class/' + $route.params.class_id + '/members'">Members</router-link>
        </el-menu-item>
      </el-menu>
    </el-col>
    <el-col :span="4">
      <div class="header-button-group">
        <el-button icon="el-icon-menu" circle v-on:click="backToClassroomList"></el-button>
      </div>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: "ClassroomHeader",
  props: {
    activeIndex: String,
    className: String
  },
  methods: {
    backToClassroomList() {
      this.$router.push("/classroom-list");
    }
  }
};
</script>

<style>
.el-menu-item {
  padding: 0;
}
.el-menu-item > * {
  padding: 0 20px;
  text-decoration: none;
  display: inline-block;
}
.header-button-group {
  height: 61px;
  line-height: 61px;
  float: right;
}
.header-class-info {
  margin-left: 40px;
  height: 61px;
  line-height: 61px;
  font-size: 20px;
  font-weight: 600;
}
</style>